import useStoreConfigController from '@/components/config-editor/hooks/useStoreConfigController';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface StoreConfigStringProps {
  value: string;
  onChange: (value: string) => void;
  path?: string;
  onFocus?: (id: string, value: string) => void;
  id: string;
}

function StoreConfigString({
  path = 'colors.primary',
  value,
  onChange,
  onFocus,
  id,
}: StoreConfigStringProps) {
  const { baseValue, isBaseDifferent, restoreBaseValue } = useStoreConfigController({
    path,
    onChange,
    value,
  });

  return (
    <div className="flex flex-col gap-2">
      <Input
        id={id}
        value={value}
        onChange={(e) => {
          onChange?.(e.target.value);
        }}
        onFocus={() => onFocus?.(id, value)}
      />
      {isBaseDifferent && (
        <div className="text-sm text-gray-500">
          <span>
            Store config value: <mark className="bg-muted px-1">{baseValue}</mark>
          </span>{' '}
          <Button variant="link" onClick={restoreBaseValue}>
            Use store config value
          </Button>
        </div>
      )}
    </div>
  );
}

export default StoreConfigString;
